module.exports = __webpack_public_path__ + "static/media/pic_empty_scanteams.e7d71b76.svg";